const storeConfigModel = {
  // * 大健康 - 门店系统模块 页面鉴权白名单
  STORE_WHITE_PATH_LIST: [
    '/store/storeCustomerManagement',
    '/store/healthUserDetail',
    '/store/storeCustomerDetail',
    '/store/storeMemberManage',
    '/store/storeConsumptionList',
    '/store/storeTeam',
    '/store/storeAgentTopics',
    '/store/downloadCenter',
    '/store/storeRecord',
    '/store/operationStatement',
    '/store/collectCard',
    '/store/collectCard/record',
    '/store/payGift',
    '/store/payGift/records',
    '/store/deliveryNoteLogistics',
    '/store/verify/verifyRecord',
    '/store/storeAgentDetail',
    '/store/storeAgentPerformance',
    '/store/commission/detail',
    '/storeCommission/withdrawalrecord',
    '/store/orderKPI',
    '/store/commission/incomepage',
    '/store/commission/incomepagemanual',
    '/store/commission/balanceDetail',
    '/store/couponDetail',
    '/store/liveApplication/success',
    '/store/tradeComplaint',
  ],

  // * 门店系统 不需要校验登录状态的页面
  NO_LOGIN_PATH: [],

  // * token key 值
  TOKEN_KEY: 'vzan_store_authorization',

  // * userInfo key值
  USER_INFO_KEY: 'vzan_store_user_info',
}

export default storeConfigModel
